import apiConfig from "./api-config";

const baseUrl = `${apiConfig.api_base_url}/api/v1/wordpress`;

function authHeaders(json = false) {
  const token = sessionStorage.getItem("authToken");
  return {
    Accept: "application/json",
    Authorization: `Bearer ${token || ""}`,
    ...(json ? { "Content-Type": "application/json" } : {}),
  };
}

async function request(path, options = {}) {
  const response = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: {
      ...authHeaders(options.body !== undefined),
      ...(options.headers || {}),
    },
  });

  if (response.status === 204) return null;
  let payload = null;
  try {
    payload = await response.json();
  } catch (_error) {
    // A structured error below is more useful than exposing JSON parse details.
  }
  if (!response.ok || payload?.success === false) {
    const error = new Error(payload?.error?.message || "The WordPress integration request failed");
    error.code = payload?.error?.code || `HTTP_${response.status}`;
    error.status = response.status;
    error.details = payload?.error?.details || null;
    throw error;
  }
  return payload?.data ?? payload;
}

export const wordpressApiBase = baseUrl;

export const listWordpressSites = () => request("/sites");

export const registerWordpressSite = ({ siteUrl, displayName }) => request("/sites", {
  method: "POST",
  body: JSON.stringify({ siteUrl, displayName }),
});

export const deleteWordpressSite = (siteId) => request(`/sites/${encodeURIComponent(siteId)}`, {
  method: "DELETE",
});

export const listWordpressSiteKeys = (siteId) => request(`/sites/${encodeURIComponent(siteId)}/keys`);

export const createWordpressSiteKey = (siteId) => request(`/sites/${encodeURIComponent(siteId)}/keys`, {
  method: "POST",
  body: JSON.stringify({}),
});

export const revokeWordpressSiteKey = (siteId, keyId) => request(
  `/sites/${encodeURIComponent(siteId)}/keys/${encodeURIComponent(keyId)}`,
  { method: "DELETE" }
);
